/**
 * Centralized localStorage / sessionStorage keys.
 * Never hardcode these strings elsewhere.
 *
 * SECURITY NOTE: JWT_TOKEN currently lives in localStorage (XSS-vulnerable).
 * Migration path: move to HttpOnly cookie on the backend and delete this entry.
 */
export const STORAGE_KEYS = {
  JWT_TOKEN: 'jwt_token',
  /** Optional: populated once the backend ships refresh-token endpoints. */
  REFRESH_TOKEN: 'refresh_token',
  SELECTED_PROJECT_ID: 'selected_project_id',
  USER_TIMEZONE: 'user_timezone',
} as const;

export type StorageKey = (typeof STORAGE_KEYS)[keyof typeof STORAGE_KEYS];
